module.exports = __webpack_public_path__ + "assets/img/81b056e83082248b71556a15063b1fb1.svg";